import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { ShapeState2D } from '../../../../cross-team-shared/annotation/shared/state/shape-state';
import { MouseEventService } from '../../../../cross-team-shared/misc-services/events/mouse-event.service';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { getShapeHelper } from '../../shape-helpers/get-shape-helper';
import { AbstractSensorContentStore2D } from '../../state/abstract-sensor-content-store-2d';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- svg needs attribute selectors
  selector: '[h3InteractiveBorderLine]',
  templateUrl: './interactive-border-line.component.html',
  styleUrls: ['./interactive-border-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InteractiveBorderLineComponent implements OnInit {
  @Input({ required: true }) p1!: Point2D;
  @Input({ required: true }) p2!: Point2D;
  @Input({ required: true }) lineIndex!: number;
  @Input({ required: true }) shapeStore!: Store<ShapeState2D>;
  cursor$!: Observable<string | undefined>;

  private store = inject(AbstractSensorContentStore2D);

  private mouseEventService = inject(MouseEventService);

  ngOnInit() {
    const shapeHelper = getShapeHelper(this.shapeStore.state().type);
    this.cursor$ = this.store('editMode').$.pipe(
      distinctUntilChanged(),
      map((editMode) =>
        shapeHelper.getCursorForInteractiveBorder(editMode, this.lineIndex),
      ),
    );
  }

  handleMouseEvent(event: MouseEvent) {
    this.mouseEventService.handle({
      target: 'interactiveBorder',
      event,
      shapeStore: this.shapeStore,
      lineIndex: this.lineIndex,
    });
  }
}
